export default __webpack_public_path__ + "static/media/arrow-right.5731a78c.svg";